const initialStateState = {
  state: [],
  update_state: false,
};

export default initialStateState;